import { c as _c } from "react/compiler-runtime";
import { TaxUnitSelector } from "../../../TaxUnitSelector/TaxUnitSelector";
import { TaxUnitCreateModal } from "../../../TaxUnitModal/TaxUnitCreateModal";
import AnimateHeight from "react-animate-height";
import { Toggle } from "../../../../../shared/components/Widget/components/shared/Toggle/Toggle";
import { DatePickerInput, DatePickerInputConfiguration } from "../../../../../shared/components/DatePicker/DatePickerInput";
import style from "./AgreementSingleCauseAreaDetails.module.scss";
import { Distribution, TaxUnit } from "../../../../../../models";
import { DistributionController } from "../../../DistributionCauseAreaInput/Distribution";
import { useState } from "react";
import { setCauseAreaStandardSplit } from "../../../distributionAmounts";
export const AgreementSingleCauseAreaDetails: React.FC<{
  distribution: Distribution;
  savedDistribution: Distribution;
  setDistribution: (dist: Distribution) => void;
  day: number;
  setDay: (day: number) => void;
  sum: number;
  setSum: (sum: number) => void;
  onSumChange: (sum: number) => void;
  taxUnits: TaxUnit[];
  dateSelectorConfig: DatePickerInputConfiguration;
  dateDisabled?: boolean;
}> = t0 => {
  const $ = _c(50);
  const {
    distribution,
    savedDistribution,
    setDistribution,
    day,
    setDay,
    sum,
    setSum,
    onSumChange,
    taxUnits,
    dateSelectorConfig,
    dateDisabled
  } = t0;
  const [addTaxUnitOpen, setAddTaxUnitOpen] = useState(false);
  let t1;
  if ($[0] !== distribution.taxUnitId || $[1] !== taxUnits) {
    let t2;
    if ($[3] !== distribution.taxUnitId) {
      t2 = unit => unit.id === distribution.taxUnitId;
      $[3] = distribution.taxUnitId;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = taxUnits.find(t2);
    $[0] = distribution.taxUnitId;
    $[1] = taxUnits;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const currentTaxUnit = t1;
  const causeArea = distribution.causeAreas[0];
  let t2;
  if ($[5] !== setDay) {
    t2 = date => setDay(date);
    $[5] = setDay;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== dateDisabled || $[8] !== dateSelectorConfig || $[9] !== day || $[10] !== t2) {
    t3 = <div className={style.valuesDatePickerContainer}><DatePickerInput selected={day} onChange={t2} configuration={dateSelectorConfig} disabled={dateDisabled} /></div>;
    $[7] = dateDisabled;
    $[8] = dateSelectorConfig;
    $[9] = day;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== causeArea.amount || $[13] !== causeArea.standardSplit || $[14] !== onSumChange || $[15] !== sum) {
    t4 = <div className={style.valuesAmountContainer}>{causeArea.standardSplit ? <><input type="text" value={formatSum(sum.toString())} onChange={e => onSumChange(parseSum(e.currentTarget.value))} data-cy="agreement-list-amount-input" /><span>kr</span></> : <><output className={style.calculatedAmount} data-cy="agreement-list-amount-input">{formatSum((causeArea.amount ?? 0).toString())}</output><span>kr</span></>}</div>;
    $[12] = causeArea.amount;
    $[13] = causeArea.standardSplit;
    $[14] = onSumChange;
    $[15] = sum;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const t5 = currentTaxUnit?.archived === null ? currentTaxUnit : null;
  let t6;
  if ($[17] !== distribution || $[18] !== setDistribution) {
    t6 = unit_0 => setDistribution({
      ...distribution,
      taxUnitId: unit_0.id
    });
    $[17] = distribution;
    $[18] = setDistribution;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setAddTaxUnitOpen(true);
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t5 || $[22] !== t6) {
    t8 = <div className={style.valuesTaxUnitSelectorContainer}><TaxUnitSelector selected={t5} onChange={t6} onAddNew={t7} /></div>;
    $[21] = t5;
    $[22] = t6;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="caption">Smart fordeling</span>;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== causeArea || $[26] !== distribution || $[27] !== setDistribution || $[28] !== setSum) {
    t10 = active => {
      const nextCauseArea = setCauseAreaStandardSplit(causeArea, active);
      setDistribution({
        ...distribution,
        causeAreas: [nextCauseArea]
      });
      setSum(nextCauseArea.amount ?? 0);
    };
    $[25] = causeArea;
    $[26] = distribution;
    $[27] = setDistribution;
    $[28] = setSum;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== causeArea.standardSplit || $[31] !== t10) {
    t11 = <div className={style.valuesSmartDistributionToggle}>{t9}<Toggle active={causeArea.standardSplit} onChange={t10} /></div>;
    $[30] = causeArea.standardSplit;
    $[31] = t10;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t11 || $[34] !== t3 || $[35] !== t4 || $[36] !== t8) {
    t12 = <div className={style.values}>{t3}{t4}{t8}{t11}</div>;
    $[33] = t11;
    $[34] = t3;
    $[35] = t4;
    $[36] = t8;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== distribution || $[39] !== savedDistribution || $[40] !== setDistribution) {
    t13 = distribution.causeAreas.map((causeArea_0, index) => <AnimateHeight key={index} height={causeArea_0.standardSplit ? 0 : "auto"} animateOpacity={true}><DistributionController causeArea={causeArea_0} savedCauseArea={savedDistribution.causeAreas.find(saved => saved.id === causeArea_0.id)} onChange={causeArea_1 => {
        const causeAreas = [...distribution.causeAreas];
        causeAreas[index] = causeArea_1;
        setDistribution({
          ...distribution,
          causeAreas
        });
      }} /></AnimateHeight>);
    $[38] = distribution;
    $[39] = savedDistribution;
    $[40] = setDistribution;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  let t14;
  if ($[42] !== addTaxUnitOpen || $[43] !== distribution || $[44] !== setDistribution) {
    t14 = addTaxUnitOpen && <TaxUnitCreateModal open={addTaxUnitOpen} onFailure={_temp} onSuccess={unit_1 => {
      setDistribution({
        ...distribution,
        taxUnitId: unit_1.id
      });
      setAddTaxUnitOpen(false);
    }} onClose={() => setAddTaxUnitOpen(false)} />;
    $[42] = addTaxUnitOpen;
    $[43] = distribution;
    $[44] = setDistribution;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  let t15;
  if ($[46] !== t12 || $[47] !== t13 || $[48] !== t14) {
    t15 = <>{t12}{t13}{t14}</>;
    $[46] = t12;
    $[47] = t13;
    $[48] = t14;
    $[49] = t15;
  } else {
    t15 = $[49];
  }
  return t15;
};

/**
 * Take input sum and add a thin seperator between every 3rd digit.
 */
const formatSum = (sum: string) => {
  const parts = sum.split(".");
  const formatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return parts.length === 2 ? formatted + "." + parts[1] : formatted;
};

/**
 * Strip thin seperator from sum and return a number.
 */
const parseSum = (sum: string) => {
  return parseInt(sum.replace(/ /g, ""), 10) || 0;
};
function _temp() {}